import React, { useContext, useMemo, useState } from "react";
import Keycloak from "keycloak-js";

const authContextObject = React.createContext<any>({
  init: (conf: any) => { },
  isInitialized: false,
  isAuthenticated: () => false,
  keycloakLoading: false,
  logout: () => { }
});

const useAuth = () => useContext(authContextObject);

const AuthContextProvider = ({ children }: any) => {
  const [keycloak, setKeycloak] = useState<any>();
  const [isInitialized, setIsInitialized] = useState<any>(false);
  const [keycloakLoading,setKeycloakLoading] = useState(false)

  const isAuthenticated = () => keycloak?.authenticated || false;

  const logout = () => {
    localStorage.clear();
    keycloak.logout();
  };

  const initKeycloak = (config: any) => {
    setKeycloakLoading(true)
    const keycloakLocal = new (Keycloak as any)(config);
    keycloakLocal.init({
      onLoad: 'check-sso',
    }).then(function (authenticated: any) {
      console.log("Kecloak initialization response:=>", authenticated)
      if (authenticated) {
        keycloakLocal.redirectUri = window.location.origin
        setKeycloak(keycloakLocal);
        const tokenValue = localStorage.getItem('token')
        if(!tokenValue){
          // @ts-ignore
          amplitude.logEvent(`login_success`)
        }
        setIsInitialized(true);
        if (keycloakLocal.token) {
          localStorage.setItem('token', keycloakLocal.token)
          // @ts-ignore
          amplitude.setUserId(keycloakLocal.tokenParsed.email);
          // @ts-ignore
          console.log(keycloakLocal.tokenParsed.email);
          setKeycloakLoading(false);
        }
      } else {
        keycloakLocal.login({ idpHint: config.idpHint });
      }
    }).catch((err: any) => {
      setIsInitialized(false);
      setKeycloakLoading(false);
      console.log("Kecloak initialization error::=>", err)
    })
  };

  const value = useMemo(
    () => ({
      init: initKeycloak,
      isInitialized,
      isAuthenticated: isAuthenticated(),
      keycloakLoading,
      logout
    }),
    [isInitialized, isAuthenticated, initKeycloak, keycloakLoading,logout]
  );

  return (
    <authContextObject.Provider
      value={value}>
      {children}
    </authContextObject.Provider>
  );
};

export { useAuth, AuthContextProvider };